import { Box, Typography } from "@mui/material";
import React from "react";
import "../common/styles/colors.scss";
import "./components.scss";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { replaceRelationWithKeys } from "./../utils/FTUtilities";

export const PieChart = (props) => {
  const { t } = useTranslation();
  const { options } = props;
  const series = options?.map((option) => option.series);
  const chartOptions = {
    labels: options?.map((option) => t(replaceRelationWithKeys(option.role))),
    colors: options?.map((option) => option.color),
    legend: {
      formatter: function (series) {
        return series.length > 8 ? series.substring(0, 8) + "..." : series;
      },
      fontSize: "12px",
      fontWeight: 400,
      offsetY: -18,
      offsetX: 0,
      itemMargin: {
        horizontal: 5,
        vertical: 0,
      },
      markers: {
        width: 12,
        height: 12,
      },
    },
    stroke: {
      colors: ["transparent"],
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return value + "%";
        },
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "50%",
          labels: {
            show: false,
          },
        },
      },
    },
  };
  return (
    <Box component="div" className="pie-chart-container" marginBottom={2}>
      <Typography textAlign="center" fontSize="14px">
        {t("ft-page-chart-text")}
      </Typography>
      <Box className="donut-chart-block">
        <Chart
          options={chartOptions}
          series={series}
          type="donut"
          width={215}
        />
      </Box>
    </Box>
  );
};
